module.exports = __webpack_public_path__ + "img/noMenu1.b7a2b685.png";